import { isFunction } from 'lodash'
import React, { useContext } from 'react'
import { Field as FinalField, FieldRenderProps } from 'react-final-form'

import FieldContext from './FieldContext'

type TReadonly<T = string | number | unknown[] | Record<string, unknown>> = {
  children?:
    | React.ReactNode
    | ((value: T | FieldRenderProps<T, HTMLElement, T>) => React.ReactNode)
  raw?: boolean
  name?: string
}
const Readonly = <T = string | number | unknown[] | Record<string, unknown>,>(
  props: TReadonly<T>,
): React.ReactElement => {
  const { children, raw, name } = props

  const { prefix } = useContext(FieldContext)

  const fieldName = prefix ? `${prefix}.${name}` : name

  return (
    <FinalField<T>
      subscription={{ value: true }}
      {...props}
      name={fieldName as string}
    >
      {(field) => {
        const { input } = field
        const { value } = input
        return isFunction(children)
          ? children(raw ? field : value) || null
          : children
      }}
    </FinalField>
  )
}

export default Readonly
